import React from 'react';
import { useTranslation } from 'react-i18next';
import UserLink from '../../User/Link/UserLink';
export var License = function (_a) {
    var _b = _a.license, license = _b === void 0 ? 'none' : _b, publishedTime = _a.publishedTime, author = _a.author;
    var t = useTranslation().t;
    var publishedYear = publishedTime && new Date(publishedTime).getFullYear();
    var currentYear = new Date().getFullYear();
    var years = !publishedYear || publishedYear === currentYear
        ? currentYear
        : publishedYear + " - " + currentYear;
    if (license === 'none') {
        return (React.createElement(React.Fragment, null, " \u00A9 " + years + " ",
            author && React.createElement(UserLink, { user: author })));
    }
    return (React.createElement("a", { rel: "license", target: "_blank", href: "http://creativecommons.org/licenses/" + license + "/3.0/" }, t("deviation.details.license." + license)));
};
License.displayName = 'License';
export default License;
//# sourceMappingURL=License.js.map